
const Error = () => {
  return (
    <section className='overflow-hidden'>
        <div className={`flex justify-center items-center h-screen`} >
            <div className="w-[372px] h-[444px] bg-[#F3F5FF] flex flex-col justify-center items-center rounded-lg border border-gray-300  font-Neue">
                <h1 className="mt-3 text-red-600 text-xl font-semibold">Unsuccessful</h1>
                <p className="mt-1 text-red-600 text-base font-medium">Your trip was not found</p>
                <img src="https://static.vecteezy.com/system/resources/thumbnails/009/344/493/small/x-transparent-free-png.png" width={300} height={300} alt='error'/>
            </div>
        </div>
    </section>
  )
}

export default Error